export default function NotFound() {
  return (
    <div class="flex h-screen flex-col items-center justify-center">
      <h1 class="text-4xl font-bold">404</h1>
      <p class="mt-2 text-gray-500">Page not found</p>
      <a href="/" class="mt-4 text-blue-600 hover:underline">Go home</a>
    </div>
  );
}
